import React from 'react';

interface SpaceProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  direction?: 'vertical' | 'horizontal';
  className?: string;
}

/**
 * A simple component to add spacing between elements
 */
const Space: React.FC<SpaceProps> = ({
  size = 'md',
  direction = 'vertical',
  className = '',
}) => {
  // Get space size
  const getSizeClass = () => {
    switch (size) {
      case 'xs':
        return direction === 'vertical' ? 'h-2' : 'w-2';
      case 'sm':
        return direction === 'vertical' ? 'h-4' : 'w-4';
      case 'md':
        return direction === 'vertical' ? 'h-6' : 'w-6';
      case 'lg':
        return direction === 'vertical' ? 'h-8' : 'w-8';
      case 'xl':
        return direction === 'vertical' ? 'h-12' : 'w-12';
      default:
        return direction === 'vertical' ? 'h-6' : 'w-6';
    }
  };

  return <div className={`${getSizeClass()} ${className}`} />;
};

export default Space;